import React, { useEffect, useState } from "react";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import Radio from "../../Formik/Radio/Radio";
import Modal from "../Modal/Modal";
import Button from "../../Button/Button";
import styles from "./PaymentModeModal.module.scss";
import { useSelector } from "react-redux";
import { formatPrice } from "../../../../utils/utils";
import ErrorText from "../../Formik/ErrorText/ErrorText";

const PaymentModeModal = ({
  show,
  handleClose,
  paymentMode,
  setPaymentMode,
  handleSubmit,
  setWalletType,
}) => {
  const paymentModes = [
    {
      title: "Stripe Payment",
      value: "STRIPE",
      text: "3% fees will be charged for Stripe payment",
      isDisabled: false,
      isChecked: false,
      balance: "",
    },
    {
      title: "Wire Payment",
      value: "WIRE",
      // text: "Invest large amount",
      isDisabled: false,
      isChecked: false,
      balance: "",
    },
  ];

  return (
    <>
      <Modal
        show={show}
        handleClose={() => {
          handleClose();
        }}
        className={styles.options_modal}
        title={
          <>
            <span
              onClick={() => {
                handleClose();
              }}
            >
              <LeftArrowIcon />
              Back
            </span>
          </>
        }
        hideCloseBtn={true}
      >
        <div className={styles.options_modal_body}>
          {paymentModes?.map((item, index) => (
            <label key={index}>
              <div className={styles.radio}>
                <Radio
                  name="payment_method"
                  value={item.value}
                  checked={paymentMode === item?.value}
                  onChange={(event) => {
                    setPaymentMode(event.target.value);
                    setWalletType(event.target.value);
                  }}
                />
              </div>
              <div>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </label>
          ))}
          <Button fluid className={styles.submit_btn} onClick={handleSubmit}>
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default PaymentModeModal;
